import { render, staticRenderFns } from "./NavigationProductList.vue?vue&type=template&id=f742c6fc&"
import script from "./NavigationProductList.vue?vue&type=script&lang=js&"
export * from "./NavigationProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports